import styled from "styled-components";


export const ExternalLinkIframeContainerBox = styled.div<{width: number; height: number}>`
  position: relative;
  width: ${props => props.width + 'px'};
  height: ${props => props.height + 'px'};
  box-sizing: border-box;
  @media ${({theme}) => theme.mediaQuery.lAndBelow} {
    width: 100%;
    height: 100%;
  }
  
`